import React from "react";
import { Outlet } from "react-router-dom";

const Patients = () => {
  return <Outlet />;
};

export default Patients;
